export function useOnboardingDevMode() {
  return window.location.origin.includes('localhost');
}
